export default "__VITE_ASSET__dfb13a91__"